import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ViewErrorBoundary } from './components/common/ViewErrorBoundary.tsx';
import './styles/index.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ViewErrorBoundary viewName="Pulse Workspace">
        <App />
      </ViewErrorBoundary>
    </React.StrictMode>
  );
}

// In local development, purge any stale service workers to prevent cached blank screens
if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) reg.unregister();
    });
  } else {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('Service worker registration failed:', err);
      });
    });
  }
}
